import { registerPlugin } from '@capacitor/core';

import type { SafeAreaFixPlugin } from './definitions';

const SafeAreaFix = registerPlugin<SafeAreaFixPlugin>('SafeAreaFix', {
  web: () => import('./web').then((m) => new m.SafeAreaFixWeb()),
});

export * from './definitions';
export { SafeAreaFix };
